import(/* webpackMode: "eager" */ "/vercel/path0/src/app/footer/ca-privacy/page.js");
